import { render, staticRenderFns } from "./PushNotiBox.vue?vue&type=template&id=347b2337&scoped=true"
import script from "./PushNotiBox.vue?vue&type=script&lang=ts"
export * from "./PushNotiBox.vue?vue&type=script&lang=ts"
import style0 from "./PushNotiBox.vue?vue&type=style&index=0&id=347b2337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347b2337",
  null
  
)

export default component.exports